<template>
  <div class="modal fade" id="hei-program-edit-modal" tabindex="-1" role="dialog">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Edit Program</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <form @submit.prevent="save">
          <div class="modal-body">
            <div class="form-group">
              <label>Program</label>
              <input
                type="text"
                class="form-control"
                v-model="form.program_name"
                disabled
              />
            </div>

            <div class="form-group">
              <label><span class="text-danger">*</span> Academic Year</label>
              <select v-model="form.academic_year_id" class="custom-select" required>
                <option value="" selected hidden disabled>Choose</option>
                <option v-for="ay in academicYears" :key="ay.id" :value="ay.id">
                  {{ ay.academic_year }}
                </option>
              </select>
            </div>

            <div class="form-row">
              <div class="col form-group">
                <label
                  ><span v-if="!isCertificateInTeaching" class="text-danger">*</span>
                  Permit Number</label
                >
                <input
                  v-model="form.permit_no"
                  type="text"
                  class="form-control"
                  :required="!isCertificateInTeaching"
                />
              </div>
              <div class="col form-group">
                <label
                  ><span v-if="!isCertificateInTeaching" class="text-danger">*</span>
                  Date issued</label
                >
                <input
                  v-model="form.date_issued"
                  type="date"
                  class="form-control"
                  :required="!isCertificateInTeaching"
                />
              </div>
            </div>

            <div class="form-group">
              <label>Permit File</label>
              <div v-if="form.permit_no_file_path" class="mb-1">
                <button
                  type="button"
                  class="btn btn-link px-0 py-0 small"
                  @click.prevent="openUrl(form.permit_no_file_path)"
                >
                  <i class="bi bi-file-pdf"></i> View current file
                </button>
              </div>
              <div class="input-group">
                <div class="custom-file">
                  <input
                    type="file"
                    class="custom-file-input"
                    id="hei-program-edit-file-input"
                    accept=".pdf"
                    @change="onFileChange"
                  />
                  <label class="custom-file-label" for="hei-program-edit-file-input">
                    {{ selectedFile ? selectedFile.name : "Choose PDF file" }}
                  </label>
                </div>
                <div class="input-group-append">
                  <button
                    type="button"
                    class="btn btn-outline-secondary"
                    :disabled="!selectedFile || fileUploading"
                    @click.prevent="uploadPermitFile"
                  >
                    <span
                      v-if="fileUploading"
                      class="spinner-border spinner-border-sm mr-1"
                    ></span>
                    {{ fileUploading ? "Uploading..." : "Upload" }}
                  </button>
                </div>
              </div>
            </div>

            <div class="form-row">
              <div class="col form-group">
                <label
                  ><span v-if="!isCertificateInTeaching" class="text-danger">*</span>
                  Accreditation Level</label
                >
                <select v-model="form.accreditation_level" class="custom-select">
                  <option value="" selected hidden disabled>Select level</option>
                  <option value="Level V">Candidate</option>
                  <option value="Level V">No Accreditation</option>
                  <option value="Level I">Level I</option>
                  <option value="Level II">Level II</option>
                  <option value="Level III">Level III</option>
                  <option value="Level IV">Level IV</option>
                </select>
              </div>
              <div class="col form-group">
                <label>Validity</label>
                <input type="date" class="form-control" v-model="form.validity" />
              </div>
            </div>

            <div class="form-group">
              <label>Program Head</label>
              <input
                v-model="form.program_chair"
                type="text"
                class="form-control"
                placeholder="Enter complete name"
              />
            </div>

            <div class="form-row">
              <div class="col form-group">
                <label>ATOP Category</label>
                <select v-model="form.atop_cat" class="custom-select">
                  <option value="" selected hidden disabled>Select category</option>
                  <option value="GP">GP</option>
                  <option value="GR">GR</option>
                  <option value="RRPA">RRPA</option>
                  <option value="COPC">COPC</option>
                  <option value="BR">BR</option>
                  <option value="CCO">CCO</option>
                </select>
              </div>
              <div class="col form-group">
                <label>ATOP Serial</label>
                <input
                  v-model="form.atop_serial"
                  type="text"
                  class="form-control"
                  placeholder="e.g. 001"
                />
              </div>
            </div>

            <div class="form-row">
              <div class="col form-group">
                <label>ATOP Year</label>
                <select v-model="form.atop_year" class="custom-select">
                  <option value="" selected hidden disabled>Select year</option>
                  <option v-for="year in atopYears" :key="year" :value="year">
                    {{ year }}
                  </option>
                </select>
              </div>
              <div class="col form-group">
                <label>Academic Type</label>
                <select v-model="form.academic_type" class="custom-select">
                  <option value="" selected hidden disabled>Select type</option>
                  <option value="Basic">Basic</option>
                  <option value="Vocational">Vocational</option>
                  <option value="Pre Baccalaureate">Pre Baccalaureate</option>
                  <option value="Baccalaureate">Baccalaureate</option>
                  <option value="Post Baccalaureate">Post Baccalaureate</option>
                  <option value="Master">Master</option>
                  <option value="Doctoral">Doctoral</option>
                </select>
              </div>
            </div>

            <div class="form-group mb-0">
              <label><span class="text-danger">*</span> Status</label>
              <select v-model="form.status" class="custom-select" required>
                <option value="Active">Active</option>
                <option value="Inactive">Inactive</option>
                <option value="Closed">Closed</option>
                <option value="Change of Nomenclature">Change of Nomenclature</option>
                <option value="Gradual Phase Out">Gradual Phase Out</option>
                <option value="Phased out">Phased out</option>
                <option value="Deferred">Deferred</option>
              </select>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-link" data-dismiss="modal">Close</button>
            <button type="submit" class="btn btn-primary" :disabled="saving">
              <span v-if="saving" class="spinner-border spinner-border-sm mr-1"></span>
              Update
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "HeiProgramEditModal",
  data() {
    return {
      academicYears: [],
      saving: false,
      selectedFile: null,
      fileUploading: false,
      prefix: "https://drive.google.com/file/d/",
      form: new Form({
        program_id: "",
        hei_program_id: "",
        hei_code: "",
        academic_year_id: "",
        program_name: "",
        status: "",
        permit_no: "",
        date_issued: "",
        accreditation_level: "",
        validity: "",
        program_chair: "",
        permit_no_file_path: "",
        atop_cat: "",
        atop_serial: "",
        atop_year: "",
        academic_type: "",
      }),
    };
  },
  computed: {
    atopYears() {
      const current = new Date().getFullYear();
      const years = [];
      for (let y = current; y >= 1950; y--) years.push(y);
      return years;
    },
    isCertificateInTeaching() {
      return (this.form.program_name || "")
        .toLowerCase()
        .includes("certificate in teaching");
    },
  },
  methods: {
    open(program) {
      this.selectedFile = null;
      this.form.fill({
        ...program,
        hei_program_id: program.hei_program_id || program.id,
      });
      $("#hei-program-edit-modal").modal("show");
    },
    openUrl(path) {
      window.open(this.prefix + path + "/view", "_blank");
    },
    onFileChange(e) {
      this.selectedFile = e.target.files[0] || null;
    },
    uploadPermitFile() {
      if (!this.selectedFile) return;
      this.fileUploading = true;
      const formData = new FormData();
      formData.append("file", this.selectedFile);
      formData.append("hei_code", this.form.hei_code);
      formData.append("program_id", this.form.program_id);
      axios
        .post("api/hei-programs/file-upload", formData)
        .then((response) => {
          this.form.permit_no_file_path = response.data.path;
          this.selectedFile = null;
          document.getElementById("hei-program-edit-file-input").value = "";
          toastr.success("File uploaded successfully.", "Information");
        })
        .catch(() => {
          toastr.error("Failed to upload file.", "Error");
        })
        .finally(() => {
          this.fileUploading = false;
        });
    },
    getAcademicYears() {
      axios.get("api/academic-years").then((response) => {
        this.academicYears = response.data;
      });
    },
    save() {
      this.saving = true;
      axios
        .put("api/hei-programs/" + this.form.hei_program_id, this.form)
        .then((response) => {
          toastr.success(response.data.msg, "Information");
          $("#hei-program-edit-modal").modal("hide");
          this.$emit("saved");
        })
        .catch(() => {
          toastr.error("Something went wrong!", "Error");
        })
        .finally(() => {
          this.saving = false;
        });
    },
  },
  mounted() {
    this.getAcademicYears();
  },
};
</script>
